import {
  Briefcase,
  Building2,
  ClipboardList,
  FileText,
  Headphones,
  LayoutTemplate,
  ShoppingBag,
  type LucideIcon,
} from "lucide-react";

export interface AppTemplate {
  id: string;
  name: string;
  description: string;
  category: string;
  icon: LucideIcon;
  prompt: string;
}

export const appTemplates: AppTemplate[] = [
  {
    id: "customer-management",
    name: "客户管理系统",
    description: "客户列表、搜索、新增客户表单，适合销售团队使用。",
    category: "业务管理",
    icon: Building2,
    prompt:
      "创建一个客户管理系统，包含客户列表页、搜索栏、新增客户表单。客户表包含：姓名、手机号、邮箱、状态、创建时间。管理员可读写，普通用户只读。",
  },
  {
    id: "ai-customer-service",
    name: "AI 客服工作台",
    description: "AI 对话、知识库上传、工单提交，适合客服场景。",
    category: "AI 应用",
    icon: Headphones,
    prompt:
      "创建一个 AI 客服工作台页面，包含 AI 对话组件、帮助文档展示、知识库文件上传组件、工单表单组件。工单写入 tickets 表，客户信息写入 customers 表。",
  },
  {
    id: "ticket-approval",
    name: "工单审批系统",
    description: "工单提交、审批状态、金额条件分支，适合内部审批。",
    category: "业务管理",
    icon: ClipboardList,
    prompt:
      "创建一个工单审批系统，包含工单列表、提交工单表单、审批状态展示。工单表包含：标题、描述、金额、状态、申请人。金额大于 10000 需要总监审批。",
  },
  {
    id: "online-survey",
    name: "在线问卷调查",
    description: "问卷设计、填写、结果统计，适合活动报名或调研。",
    category: "营销工具",
    icon: FileText,
    prompt:
      "创建一个在线问卷调查应用，包含问卷列表、问卷填写页、提交成功页。问卷表包含：标题、描述、问题 JSON、提交人、提交时间。",
  },
  {
    id: "employee-directory",
    name: "员工信息库",
    description: "员工列表、部门筛选、个人信息卡片，适合 HR 管理。",
    category: "业务管理",
    icon: Briefcase,
    prompt:
      "创建一个员工信息库，包含员工列表、部门筛选、新增员工表单。员工表包含：姓名、邮箱、部门、职位、入职日期、状态。",
  },
  {
    id: "product-showcase",
    name: "产品展示站点",
    description: "产品列表、详情页、联系表单，适合小型官网。",
    category: "营销工具",
    icon: ShoppingBag,
    prompt:
      "创建一个产品展示站点，包含产品列表页、产品详情页、联系咨询表单。产品表包含：名称、描述、价格、图片、分类。",
  },
  {
    id: "content-cms",
    name: "内容发布后台",
    description: "文章管理、分类、发布状态，适合内容运营。",
    category: "内容管理",
    icon: LayoutTemplate,
    prompt:
      "创建一个内容发布后台，包含文章列表、新增文章表单、分类管理。文章表包含：标题、正文、分类、标签、发布状态、发布时间。",
  },
];
